import ArrowIcon from '@assets/icons/arrow.svg?react'
import { Portal } from '@components/Portal'
import clsx from 'clsx'
import { useEffect, useState } from 'react'

import s from './Drawer.module.scss'
import type { DrawerProps } from './Drawer.props'

export function Drawer({ children, shouldClose }: DrawerProps) {
  const [open, setOpen] = useState(false)
  const [bottom, setBottom] = useState(0)

  const closeHandler = () => {
    setBottom(0)
    setOpen(false)
    document.body.style.overflow = 'auto'
  }

  const toggleOpen = () => {
    if (open) {
      closeHandler()
    } else {
      const windowHeight = window.innerHeight
      const position = document.getElementById('total-root')?.getBoundingClientRect()
      const bottom = windowHeight - (position?.top || 0)

      setBottom(bottom)
      setOpen(true)
      document.body.style.overflow = 'hidden'
    }
  }

  useEffect(() => {
    if (shouldClose) {
      closeHandler()
    }
  }, [shouldClose])

  useEffect(() => {
    return () => closeHandler()
  }, [])

  return (
    <>
      <button
        type="button"
        className={s.btn}
        onClick={toggleOpen}
      >
        <ArrowIcon className={clsx(s.icon, { [s.active]: open })} />
      </button>

      <Portal id="total-root">
        <div>
          <div
            className={clsx(s.overlay, { [s.active]: open })}
            aria-label="overlay"
            onClick={toggleOpen}
          />

          <div
            className={clsx(s.wrapper, { [s.active]: open })}
            style={{ bottom }}
          >
            <div className={s.content}>
              {children}
            </div>
          </div>
        </div>
      </Portal>
    </>
  )
}
